import { GetterTree } from 'vuex';

export default <GetterTree<example.state.ExampleState, RootState>>{};
